import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { RecurringBillEntity } from './recurring-bill'

export class RecurringBillsRepository extends BaseRepository<RecurringBillEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/recurring-bills', token, cache)
    }
}
